/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "transaction": {
        "nested": {
          "transaction_service": {
            "nested": {
              "ExternalRetrieveAuthStateRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveAuthStateRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "banklinBalanceToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveAuthStateResponse": {
                "fields": {
                  "authState": {
                    "type": "squareup.transaction.transaction_service.TransactionAuthState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ExternalOverrideDeclinedAuthRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isRecognized": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OverrideDeclinedAuthRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "banklinBalanceToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isRecognized": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "OverrideDeclinedAuthResponse": {
                "fields": {
                  "authState": {
                    "type": "squareup.transaction.transaction_service.TransactionAuthState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TransactionAuthState": {
                "values": {
                  "TRANSACTION_AUTH_UNKNOWN": 0,
                  "TRANSACTION_AUTH_RESPONSE_UNSPECIFIED": 1,
                  "TRANSACTION_AUTH_RESPONSE_TRANSACTION_RECOGNIZED": 2,
                  "TRANSACTION_AUTH_RESPONSE_TRANSACTION_NOT_RECOGNIZED": 3
                }
              },
              "TransactionService": {
                "methods": {
                  "RetrieveAuthState": {
                    "requestType": "squareup.transaction.transaction_service.RetrieveAuthStateRequest",
                    "responseType": "squareup.transaction.transaction_service.RetrieveAuthStateResponse"
                  },
                  "OverrideDeclinedAuth": {
                    "requestType": "squareup.transaction.transaction_service.OverrideDeclinedAuthRequest",
                    "responseType": "squareup.transaction.transaction_service.OverrideDeclinedAuthResponse"
                  },
                  "ExternalRetrieveAuthState": {
                    "requestType": "squareup.transaction.transaction_service.ExternalRetrieveAuthStateRequest",
                    "responseType": "squareup.transaction.transaction_service.RetrieveAuthStateResponse"
                  },
                  "ExternalOverrideDeclinedAuth": {
                    "requestType": "squareup.transaction.transaction_service.ExternalOverrideDeclinedAuthRequest",
                    "responseType": "squareup.transaction.transaction_service.OverrideDeclinedAuthResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.ExternalRetrieveAuthStateRequest && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.RetrieveAuthStateRequest && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.RetrieveAuthStateResponse && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.ExternalOverrideDeclinedAuthRequest && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.OverrideDeclinedAuthRequest && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.OverrideDeclinedAuthResponse && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.TransactionAuthState && !$root.nested?.squareup?.nested?.transaction?.nested?.transaction_service?.nested?.TransactionService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ExternalRetrieveAuthStateRequest @ squareup/transaction/transaction_service.proto at 13:1
 */
export const ExternalRetrieveAuthStateRequest = $root.lookupType('squareup.transaction.transaction_service.ExternalRetrieveAuthStateRequest');
fixType(ExternalRetrieveAuthStateRequest, {
  transactionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalRetrieveAuthStateRequest);
/**
 * SOURCE RetrieveAuthStateRequest @ squareup/transaction/transaction_service.proto at 17:1
 */
export const RetrieveAuthStateRequest = $root.lookupType('squareup.transaction.transaction_service.RetrieveAuthStateRequest');
fixType(RetrieveAuthStateRequest, {
  transactionToken: {
    notEmpty: true
  },
  banklinBalanceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveAuthStateRequest);
/**
 * SOURCE RetrieveAuthStateResponse @ squareup/transaction/transaction_service.proto at 22:1
 */
export const RetrieveAuthStateResponse = $root.lookupType('squareup.transaction.transaction_service.RetrieveAuthStateResponse');
fixType(RetrieveAuthStateResponse);
Builder.createAndAttachToType(RetrieveAuthStateResponse);
/**
 * SOURCE ExternalOverrideDeclinedAuthRequest @ squareup/transaction/transaction_service.proto at 26:1
 */
export const ExternalOverrideDeclinedAuthRequest = $root.lookupType('squareup.transaction.transaction_service.ExternalOverrideDeclinedAuthRequest');
fixType(ExternalOverrideDeclinedAuthRequest, {
  transactionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalOverrideDeclinedAuthRequest);
/**
 * SOURCE OverrideDeclinedAuthRequest @ squareup/transaction/transaction_service.proto at 31:1
 */
export const OverrideDeclinedAuthRequest = $root.lookupType('squareup.transaction.transaction_service.OverrideDeclinedAuthRequest');
fixType(OverrideDeclinedAuthRequest, {
  transactionToken: {
    notEmpty: true
  },
  banklinBalanceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OverrideDeclinedAuthRequest);
/**
 * SOURCE OverrideDeclinedAuthResponse @ squareup/transaction/transaction_service.proto at 37:1
 */
export const OverrideDeclinedAuthResponse = $root.lookupType('squareup.transaction.transaction_service.OverrideDeclinedAuthResponse');
fixType(OverrideDeclinedAuthResponse);
Builder.createAndAttachToType(OverrideDeclinedAuthResponse);
/**
 * SOURCE TransactionAuthState @ squareup/transaction/transaction_service.proto at 41:1
 */
export const TransactionAuthState = $root.lookupEnum('squareup.transaction.transaction_service.TransactionAuthState').values;
/**
 * SOURCE TransactionService @ squareup/transaction/transaction_service.proto at 48:1
 */
export const TransactionService = $root.lookupService('squareup.transaction.transaction_service.TransactionService');